const fieldsHardwareUndUmsetzung = [
  'BC_Kunde_Name',
  'BC_Kunde_Number',
  'BC_Kunde_EMail',
  'BC_Kunde_Telefon',
  'BC_Kunde_Adresse',
  'BC_Kunde_PLZ',
  'BC_Kunde_Stadt',

  'BC_Rechnung_EMail',
  'BC_UStIdNr_Kunde',

  'BC_Rechnungsanschrift_Name',
  'BC_Rechnungsanschrift_Strasse',
  'BC_Rechnungsanschrift_PLZ',
  'BC_Rechnungsanschrift_Stadt',
  'BC_Rechnungsanschrift_Land',

  'BC_Lieferanschrift_Name',
  'BC_Lieferanschrift_Strasse',
  'BC_Lieferanschrift_PLZ',
  'BC_Lieferanschrift_Stadt',
  'BC_Lieferanschrift_Land',

  'BC_LieferanschriftVerified',
  'UE_Kundendaten_LIS_Standort_abw_rechnung',

  'UE_Kundendaten_LIS_Standort_Strasse',
  'UE_Kundendaten_LIS_Standort_PLZ',
  'UE_Kundendaten_LIS_Standort_Stadt',

  'PDB_Zahlungskonditionen',
  'PDB_Anzahlungskonditionen',
  'PDB_Anzahlungsrechnung_verschickt',
]
const keyHardwareUndUmsetzung = 'Kundendaten Hardware & Umsetzung'
const formGroupHardwareUndUmsetzung = {
  key: keyHardwareUndUmsetzung,
  title: keyHardwareUndUmsetzung,
  form: keyHardwareUndUmsetzung,
}

const fieldsPlanung = [
  'BC_Kundendaten_Planung_Debitor_Name',
  'BC_Kundendaten_Planung_Debitor_Number',
  'BC_Kundendaten_Planung_Debitor_Email',
  'BC_Kundendaten_Planung_Debitor_Telefon',
  'BC_Kundendaten_Planung_Debitor_Adresse',
  'BC_Kundendaten_Planung_Debitor_PLZ',
  'BC_Kundendaten_Planung_Debitor_Ort',

  'BC_Kundendaten_Planung_Rechnung_Email',
  'BC_Kundendaten_Planung_UStId',
  'BC_Kundendaten_Planung_Rechnung_Name',
  'BC_Kundendaten_Planung_Rechnung_Adresse',
  'BC_Kundendaten_Planung_Rechnung_PLZ',
  'BC_Kundendaten_Planung_Rechnung_Ort',
  'BC_Kundendaten_Planung_Rechnung_Land',

  'BC_Kundendaten_Planung_Lieferung_Name',
  'BC_Kundendaten_Planung_Lieferung_Adresse',
  'BC_Kundendaten_Planung_Lieferung_PLZ',
  'BC_Kundendaten_Planung_Lieferung_Ort',
  'BC_Kundendaten_Planung_Lieferung_Land',
  'BC_Kundendaten_Planung_Zlgsbedingung',
  'PDB_Rechnung_fuer_Planung_angestossen',
]
const keyPlanung = 'Kundendaten Planung'
const formGroupPlanung = {
  key: keyPlanung,
  title: keyPlanung,
  form: keyPlanung,
}

const fieldsServicevertrag = [
  'BC_Kundendaten_Servicevertrag_Debitor_Name',
  'BC_Kundendaten_Servicevertrag_Debitor_Number',
  'BC_Kundendaten_Servicevertrag_Debitor_Email',
  'BC_Kundendaten_Servicevertrag_Debitor_Telefon',
  'BC_Kundendaten_Servicevertrag_Debitor_Adresse',
  'BC_Kundendaten_Servicevertrag_Debitor_PLZ',
  'BC_Kundendaten_Servicevertrag_Debitor_Ort',

  'BC_Kundendaten_Servicevertrag_Rechnung_Email',
  'BC_Kundendaten_Servicevertrag_UStId',
  'BC_Kundendaten_Servicevertrag_Rechnung_Name',
  'BC_Kundendaten_Servicevertrag_Rechnung_Adresse',
  'BC_Kundendaten_Servicevertrag_Rechnung_PLZ',
  'BC_Kundendaten_Servicevertrag_Rechnung_Ort',
  'BC_Kundendaten_Servicevertrag_Rechnung_Land',
  'BC_Kundendaten_Servicevertrag_Zlgsbedingung',

  'PDB_Servicevertrag_wer_bezieht_Strom',
  'PDB_SV_Kreditor_ungleich_Debitor_LIS_Gutsch',
  'PDB_Servicevertrag_Kreditor_Name',
  'PDB_Servicevertrag_Kreditor_Email',
  'PDB_Servicevertrag_Kreditor_Iban',
]
const keyServicevertrag = 'Kundendaten Servicevertrag'
const formGroupServicevertrag = {
  key: keyServicevertrag,
  title: keyServicevertrag,
  form: keyServicevertrag,
}


export const fieldOrderKundendaten = {
  [keyHardwareUndUmsetzung]: { fields: fieldsHardwareUndUmsetzung },
  [keyPlanung]: { fields: fieldsPlanung },
  [keyServicevertrag]: { fields: fieldsServicevertrag },
}

const key = 'Kundendaten'
export const formGroupKundendaten = {
  key,
  title: key,
  forms: [
    formGroupHardwareUndUmsetzung,
    formGroupPlanung,
    formGroupServicevertrag,
  ],
}